import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import SEO, { pageSEO } from "../components/seo.component";
import { Link } from "react-router-dom";
import ContactForm from "./contactForm.component";
import Contact from "./contact.component";
import servicesBg from "../assets/images/pexels-photo-7031406.jpg";

export default function SellerGuide() {
  const [open, setOpen] = useState(
    new Array(constants.SELLING_GUIDE.length).fill(false)
  );

  const seoConfig = pageSEO.sellerGuide();

  return (
    <>
      <SEO {...seoConfig} />
      <div className="w-full text-gray-800 pt-[180px]">

        {/* HERO SECTION */}
        <section className="py-20 text-center max-w-7xl mx-auto px-6">
          <h1 className="text-5xl font-semibold mb-4">Selling with Alex</h1>
          <div className="w-32 h-[2px] bg-logo-main my-3 mx-auto" />
          <h3 className="text-2xl text-black my-6 font-light">I have the tools to meet the demands of a highly competitive, modern market.</h3>
          <p className="text-black font-light leading-relaxed">
            I will work for you every step of the way! My combination of skill, experience, and technology ensures that I can sell your home for the highest possible price and in the shortest period of time.
          </p>
        </section>

        {/* SERVICE & COMMITMENT */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 mx-auto items-stretch">
          <img
            src={servicesBg}
            alt="real estate"
            className="object-cover lg:aspect-[4/3] w-full"
          />
          <div className="w-full lg:w-[70%] py-10 lg:py-8 px-6 lg:px-0">
            <h2 className="text-4xl font-semibold mb-2">Integrity and results</h2>
            <h3 className="text-xl text-black font-light mb-4">What to expect when Selling with me</h3>

            <ul className="space-y-4 list-disc pl-5 text-black font-semibold">
              <li>Pricing expertise: I will determine the best price for your home by analyzing comparable home sales in your area with current market conditions.</li>
              <li>Marketing: I will create a comprehensive marketing plan for your home including MLS® listing, social media posts, and other strategies to reach potential buyers.</li>
              <li>Showings and open houses: I will schedule and manage showings and open houses to give potential buyers a chance to view your home.</li>
              <li>Negotiations: When an offer is made on your home, I will negotiate on your behalf to help you get the best possible price and terms.</li>
              <li>Contract preparation: I can help you prepare the necessary paperwork, including the purchase agreement, disclosure forms, and other legal documents required for the sale of your home.</li>
            </ul>

            <div className="my-10 flex flex-col xl:flex-row gap-4 ">
              <Link
                to={"/evaluation"}
                className="whitespace-nowrap text-lg uppercase tracking-wider w-fit border-2 border-logo-main hover:bg-logo-third hover:border-transparent hover:text-white hover:scale-110 duration-500 ease-in-out
                                  px-5 md:px-9 py-[7px] md:py-[12px] text-logo-second font-semibold transition-all transform"
              >
                Free Home Evaluation
              </Link>
              <Link
                to={"/contact"}
                className="whitespace-nowrap text-lg uppercase tracking-wider w-fit border-2 border-logo-main hover:bg-logo-third hover:border-transparent hover:text-white hover:scale-110 duration-500 ease-in-out
                                  px-5 md:px-9 py-[7px] md:py-[12px] text-logo-second font-semibold transition-all transform"
              >
                Contact me today
              </Link>
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="bg-logo-second text-white py-20 px-6">
          <div className="max-w-7xl mx-auto text-center mb-10 space-y-6">
            <h2 className="text-5xl font-semibold">The selling process</h2>
            <p className="text-2xl">From start to finish, I'll be right There</p>
            <p>When you consider it, there are several other homes for sale competing with your property. I will help you price your home competitively to attract qualified buyers. The way I do this is by generating a Comparative Market Analysis (CMA) report, which will show you a range of prices being paid for homes in your region. You can complete my online form to get a feel for your home's market value.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-7xl mx-auto">
            {[
              {
                title: "Prepare listing",
                text: "I'll assess your home's value and, using market research, set your sale price based on many factors. We'll take great photos of your home and prepare marketing materials to show your home to as broad an audience as possible."
              },
              {
                title: "Showing your home",
                text: "Going through our buyer contacts and existing leads along with promotional campaigns and open houses, we'll expose your home to many interested buyers. We'll also arrange private showings for those who want a more personal and in-depth viewing."
              },
              {
                title: "Negotiate the sale",
                text: "Negotiating a sale can be a stressful and tense time for a homeowner. I will handle any offers and counteroffers on your behalf and take care of all the paperwork needed. My goal is to get you a fair price and terms in a smooth and timely manner."
              }
            ].map((item, i) => (
              <div key={i} className="text-white p-6 rounded-xl border border-logo-main">
                <h3 className="text-3xl font-semibold mb-4">{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* RESOURCES */}
        <section className="py-20 px-6 max-w-7xl mx-auto">
          <div className="max-w-7xl mx-auto text-center mb-10 space-y-6">
            <h2 className="text-5xl font-semibold text-center">
              Helpful Selling Resources
            </h2>
            <p className="text-2xl font-light">Ready To Go To Market?</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {constants.SELLING_RESOURCES.map((r, i) => (
              <div key={i} className="border overflow-hidden">
                <img src={r.img} alt={r.title} className="h-64 w-full object-cover overflow-hidden" />
                <div className="p-4 flex flex-col justify-between lg:h-[250px]">
                  <div className="space-y-5 mb-10 lg:mb-0">
                    <h3 className="font-semibold text-2xl">{r.title}</h3>
                    <p className="text-black font-light">{r.desc}</p>
                  </div>

                  <a className="group uppercase tracking-wider w-fit border-2 border-logo-main hover:bg-logo-third hover:border-transparent hover:text-white hover:scale-110 duration-500 ease-in-out
                  px-3 lg:px-9 py-[7px] lg:py-[12px] text-logo-second font-semibold transition-all transform inline-block"
                    href={r.url}
                    download={true}>
                    Download
                    <FontAwesomeIcon icon={faAngleRight} className="ml-3 text-lg text-logo-main group-hover:text-white transition-colors duration-300" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section >

        {/* CALL TO ACTION */}
        < section className="bg-logo-second text-white py-20 text-center px-6" >
          <div className="max-w-5xl mx-auto text-center space-y-6">
            <h2 className="text-4xl font-semibold">How Can I Help With Your Home Sale?</h2>
            <p className="mt-2 mb-6 text-2xl">I look forward to hearing from you!</p>
            <p className="text-lg font-light">Selling a home can be a complex process, but with the right preparation and guidance, it can also be a smooth and successful experience. Contact me today to learn more about how we can help you sell your home and achieve your goals!</p>
            <a href="#contact" className="uppercase tracking-wider border border-white hover:bg-logo-third hover:border-transparent text-white hover:scale-110 duration-500 ease-in-out px-5 md:px-9 py-[7px] md:py-[12px] text-logo-second font-semibold transition-all transform inline-block">
              Let’s Connect
            </a>

            <div className="flex gap-x-5 justify-center">
              {Object.entries(constants.SOCIALS)?.map(([k, v]) => (
                <a href={constants.SOCIALS[k]}>
                  <FontAwesomeIcon
                    className="fa-xl text-logo-main"
                    icon={constants.ICONS[k]}
                  />
                </a>
              ))}
            </div>
          </div>
        </section >

        {/* CONTACT FORM */}
        < ContactForm />

        <section className="py-20 px-6 max-w-7xl mx-auto text-center">
          <div className="space-y-5">
            <h3 className="text-xl font-semibold uppercase title-font-family">SELLING</h3>
            <h1 className="text-5xl font-semibold">I have the tools to meet the demands of a highly competitive, modern market.</h1>
          </div>
          <div className="w-32 md:w-96 h-[1px] bg-black my-20 mx-auto" />

          <div className="max-w-6xl mx-auto px-6">
            <div className="grid lg:grid-cols-[25%_75%] gap-12 items-start">

              {/* Quote */}
              <div>
                <blockquote className="relative text-2xl md:text-3xl font-semibold text-gray-800 lg:border-t-2 border-black text-left py-4 title-font-family">
                  I will work for you every step of the way! My combination of skill,
                  experience, and technology ensures that I can sell your home for the
                  highest possible price and in the shortest period of time.
                </blockquote>
              </div>

              {/* Content */}
              <div className="space-y-6 text-black font-light leading-relaxed text-left px-6">
                <p className="text-lg leading-8 text-left">
                  <span className="float-left text-[4.5rem] leading-[0.75] font-light mt-1">
                    M
                  </span>
                  y internet marketing system allows me to make information accessible 24-hours daily, and to respond quickly and directly to each and every potential buyer.  From my website, prospective buyers can get information immediately about your property.  They can access my site 24 hours a day and view your property listing!  Through my Personal Home Search, your listing will be transmitted by email to each prospective buyer in my database, where your home meets their standards.  Plus it'll be emailed automatically to future prospective buyers too.
                </p>
                <p className="">
                  Whenever you list your property with me, I'll add your property online so other agents can immediately access your property information.  In addition, your property will be included in any printed MLS® books.  I also regularly publish in magazines and papers in the area and send out direct mail pieces to potential buyers.
                </p>
              </div>
            </div>
          </div>
        </section>
        < section className="max-w-7xl lg:mx-auto bg-gray-200 text-black py-6 lg:py-24 px-6 lg:px-24 mx-6" >
          <div className="space-y-3">
            <h2 className="text-4xl font-semibold">Pricing Your Home</h2>
            <p className="text-lg font-semibold">When you consider it, there are several other homes for sale competing with your property.  I will help you price your home competitively to attract qualified buyers.  The way I do this is by generating a Comparative Market Analysis (CMA) report, which will show you a range of prices being paid for homes in your region.  You can complete my online form to get a feel for your home's market value.</p>
          </div>
        </section >

        < section className="max-w-5xl mx-auto text-black py-24 px-14 lg:px-24 text-center" >
          <div className="space-y-3">
            <h2 className="text-4xl font-semibold">Every Step of the Way</h2>
            <p className="text-lg font-semibold title-font-family text-gray-500">Bear in mind, I'll be working for you every step along the way to ensure you receive the greatest possible price for your house in the shortest amount of time.</p>
          </div>
        </section >

        <Contact />

      </div >
    </>
  );
}
